import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; // Importante para los links
import { ProyectosService } from '../../services/proyectos.service';

@Component({
  selector: 'app-portafolio',
  standalone: true,
  imports: [CommonModule, RouterModule], // Importamos RouterModule para usar routerLink
  templateUrl: './portafolio.html',
  styleUrls: ['./portafolio.css']
})
export class PortafolioComponent implements OnInit {

  obras: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.obras = this.proyectosService.getObras();
  }
}